// Impressum des TimeNYzer – wörtlich aus Auftrag L1 (D4). Format: siehe lib/rechtsText.js.
export const IMPRESSUM_TEXT = `# Impressum
## Angaben gemäß § 5 DDG
Das Relationship Schulbegleitung GbR
Hermannsteiner Straße 100
35614 Aßlar
**Vertreten durch:**
Jonathan Makkonen, Kemal Aydemir
## Kontakt
Telefon: +49 176 22851838
E-Mail: schulbegleitung@dasrelationship.com
## Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV
Jonathan Makkonen, Kemal Aydemir
Hermannsteiner Straße 100
35614 Aßlar
## Verbraucherstreitbeilegung gemäß § 36 VSBG
Wir nehmen nicht an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.
## Haftungsausschluss
Wir sind für die Inhalte dieser Internetseiten nach den allgemeinen Gesetzen verantwortlich. Alle Inhalte werden mit der gebotenen Sorgfalt und nach bestem Wissen erstellt. Soweit wir auf Internetseiten Dritter verlinken, können wir keine Gewähr für die fortwährende Aktualität, Richtigkeit und Vollständigkeit der verlinkten Inhalte übernehmen, da diese außerhalb unseres Verantwortungsbereichs liegen. Sollten aus Ihrer Sicht Inhalte gegen geltendes Recht verstoßen oder unangemessen sein, teilen Sie uns dies bitte mit.
## Datenschutz
Unsere Datenschutzhinweise für den TimeNYzer finden Sie unter [Datenschutz](/datenschutz).
## Urheberrecht
Die Texte, Bilder, Fotos, Videos und Grafiken auf diesen Seiten unterliegen in der Regel dem Schutz des Urheberrechts. Jede unberechtigte Verwendung, insbesondere die Vervielfältigung, Bearbeitung oder Verbreitung, ist untersagt. Wenn Sie Inhalte verwenden möchten, kontaktieren Sie uns bitte vorher unter den oben genannten Angaben.`;
